import React from 'react'
import { observer } from 'mobx-react'
import { InviteUser } from '../commonQuestions/InviteUser'
import { useTranslation } from 'react-i18next'

export default {
  title: 'Finance.AuthorisedDetails',
  component: observer((props) => {
    const { t } = useTranslation('application')
    return (
      <InviteUser
        {...props}
        reviewLabel={t('Finance.AuthDetailsReviewTitle')}
      />
    )
  }),
}
